import { RouteObject } from "react-router";

import UserCreateScreen from "./screens/UserCreateScreen";
import UserImportScreen from "./screens/UserImportScreen";
import UserListScreen from "./screens/UserListScreen";
import UserProfileScreen, { UserProfileScreenBreadcrumb } from "./screens/UserProfileScreen";
import UserShiftsScreen from "./screens/UserShiftsScreen";
import UserTimeOffScreen from "./screens/UserTimeOffScreen";
import UserUpdateScreen, { UserUpdateScreenBreadcrumb } from "./screens/UserUpdateScreen";

export const userRoutes: RouteObject[] = [
    {
        path: "users",
        handle: { breadcrumb: "user:userListScreen.title" },
        children: [
            { index: true, element: <UserListScreen /> },
            { path: "new", handle: { breadcrumb: "user:userCreateScreen.title" }, element: <UserCreateScreen /> },
            { path: "import", handle: { breadcrumb: "user:userImportScreen.title" }, element: <UserImportScreen /> },
            {
                path: ":userId",
                handle: { breadcrumb: UserUpdateScreenBreadcrumb },
                children: [
                    { index: true, element: <UserUpdateScreen /> },
                    {
                        path: "timeoff/:year?/:month?",
                        handle: { breadcrumb: "fieldworker:fieldworkerAvailabilityScreen.availabilityTitle" },
                        element: <UserTimeOffScreen />,
                    },
                    {
                        path: "shifts",
                        handle: { breadcrumb: "fieldworker:shifts.title" },
                        element: <UserShiftsScreen />,
                    },
                ],
            },
        ],
    },
];

export const userProfileRoutes: RouteObject[] = [
    {
        path: "profile",
        handle: { breadcrumb: UserProfileScreenBreadcrumb },
        element: <UserProfileScreen />,
    },
];
